<template>
  <div class="comments">
    <v-row>
      <v-col cols="12">
        <v-subheader class="font-weight-bold">Comments</v-subheader>
        <v-layout row class="flex-container">
          <v-flex xs6 sm4 v-for="(item, index) in items" :key="index">
            <v-list Two-line>
              <v-list-item>
                <v-list-item-avatar>
                  <v-img :src="item.avatar"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-text="item.title" />
                  <v-list-item-subtitle v-text="item.subtitle" />
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-flex>
        </v-layout>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
          title: 'Jaden Smith',
          subtitle: 'Amazing Job guys',
        },

        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg',
          title: 'Zak Duor',
          subtitle: 'We rock local trends',
        },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg',
          title: 'Soft Chick',
          subtitle: 'Designs caught me straight',
        },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/4.jpg',
          title: 'Nichol Babe',
          subtitle: 'Alphyiago doing the most',
        },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/5.jpg',
          title: 'Zoo Mill',
          subtitle: 'I need more',
        },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
          title: 'Jaden Smith',
          subtitle: 'Can not get enough',
        },
      ],
    }
  },
}
</script>
